<template>
    <div class="flight">
        <h5 class="flight-number d-flex align-items-center">
            <img :src="airline.logoUrl" :alt="airline.name" class="airline-logo me-3"/>
            <strong>{{airline.name}} {{flight.flightNumber}}</strong>
        </h5>
        <!--Show operating airline as required by regulation. -->
        <small v-if="flight.prettyOperatingAirlineName" class="text-muted">
            {{$t('common.itinerary.operatedBy', {operatingAirlineNames: flight.prettyOperatingAirlineName})}}
            <span v-if="flight.operatingFlightNumber && flight.operatingAirlineCode !== '**'">
                &ndash; {{flight.operatingAirlineCode}} {{flight.operatingFlightNumber}}
            </span>
        </small>
        <div class="flight-line mt-2">
            <div class="departure d-flex my-4">
                <font-awesome-icon
                    :icon="['fal', 'location-dot']"
                    fixed-width
                    class="flight-line-icon text-dark trip-line-pin me-2"
                />
                <div class="flex-grow-1">
                    <div class="lead">
                        <strong class="me-2">{{$filters.beautifyTime(flight.departureDateTime)}}</strong> {{departureAirport.city}} ({{departureAirport.iata}})
                    </div>
                </div>
            </div>

            <!--
                If Flight stops are present, show the duration to first stop instead of the entire flight duration.
            -->
            <div v-if="flight.flightStops.length === 0 || flight.durationToFirstStop" class="flight-time d-flex align-items-center my-4">
                <font-awesome-icon
                    :icon="['fal', 'plane']"
                    fixed-width
                    rotation="90"
                    class="flight-line-icon text-dark trip-line-pin me-2"
                />
                <div>{{$t('common.itinerary.flightTime', {time: flight.flightStops.length === 0 ? flight.duration : flight.durationToFirstStop})}}</div>
            </div>
            <flight-stop
                v-for="stop in flight.flightStops"
                :key="stop.id"

                :stop="stop"
                :trip="trip"
            />
            <div class="arrival d-flex align-items-end my-4">
                <font-awesome-icon
                    :icon="['fal', arrivalAirport.iata === originDestination.arrivalAirportCode ? 'location-check' : 'location-dot']"
                    fixed-width
                    class="flight-line-icon text-dark trip-line-pin me-2"
                />
                <div class="flex-grow-1">
                    <div class="lead">
                        <strong class="me-2">{{$filters.beautifyTime(flight.arrivalDateTime)}}</strong> {{arrivalAirport.city}} ({{arrivalAirport.iata}})
                    </div>
                </div>
            </div>
        </div>
        <div v-if="flight.layover" class="lead">
            <hr/>
            {{$t('common.itinerary.layoverIn', {time: flight.layover, city: arrivalAirport.city})}}
            <hr/>
        </div>
    </div>

</template>

<script>
import FlightStop from "@/components/itinerary/FlightStop";
export default {
    name: 'Flight',
    components: {FlightStop},
    props: {
        flight: {
            type: Object,
            required: true
        },
        trip: {
            type: Object,
            required: true
        },
        originDestination: {
            type: Object,
            required: true
        }
    },
    computed: {
        airline() {
            return Object.values(this.trip.pnr.airlines).find(airline => airline.iata === this.flight.airlineCode);
        },
        departureAirport() {
            return Object.values(this.trip.pnr.airports).find(airport => airport.iata === this.flight.departureAirportCode);
        },
        arrivalAirport() {
            return Object.values(this.trip.pnr.airports).find(airport => airport.iata === this.flight.arrivalAirportCode);
        }
    }
};
</script>

<style lang="scss" scoped>
.flight {
    .airline-logo {
        height: 1.75rem;
    }
    .flight-line {
        padding-left: 1.0rem;
        margin-left: 1.0rem;
        border-left: 1px solid $dark;
        > div {
            line-height: 1.0;
            margin-left: -2.0rem;
        }
        .flight-line-icon {
            font-size: 1.55rem;
            background: white;
        }
    }
}

@include media-breakpoint-down(sm) {
    .flight {
        font-size: 0.875rem;
        .lead {
            font-size: 1.0rem;
        }
        h5 {
            font-size: 1.125rem;
        }
        small: 0.75rem;
    }

}
</style>